import MapModal from 'components/desktop/detail/main-section/main-section-left/map-section/map-modal';
import {
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconLocationOutline,
} from 'components/icons';
import Carousel from 'components/shared/carousel';
import ModalWrapper from 'components/shared/modal-wrapper';
import { useModal, useTranslation } from 'hooks';
import { isEmpty } from 'lodash';
import { DetailProjectPageContext } from 'pages/du-an/[chi-tiet-du-an]';
import { useContext, useState } from 'react';

const ProjectLocation = () => {
  const translate = useTranslation();
  const { project } = useContext(DetailProjectPageContext).pageData ?? {};
  const { project: projectDetail } = project ?? {};
  const { projectLocation, projectLocationImages, map } = projectDetail ?? {};
  const { showing: showingMapModal, toggle: toggleMapModal } = useModal();
  const [isExpandAccordion, setExpandAccordion] = useState(true);

  const toggleExpandAccordion = () => {
    setExpandAccordion(!isExpandAccordion);
  };

  return !isEmpty(projectLocationImages) || projectLocation || map ? (
    <section id='project-location' className='w-full rounded-[16px] bg-paper p-[24px] shadow-7'>
      <div className='flex justify-between'>
        <div className='flex items-center'>
          <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
            <IconLocationOutline className='h-[18px] w-[18px]' />
          </div>
          <h2 className='ml-[8px] text-[18px] font-[600] leading-[23px]'>
            {translate.desktop.detailProject.projectLocation}
          </h2>
        </div>
        <div
          className='flex cursor-pointer select-none items-center text-primary'
          onClick={toggleExpandAccordion}
        >
          <span className='text-[12px] leading-[15px]'>
            {isExpandAccordion ? 'Ẩn bớt' : 'Xem thêm'}
          </span>
          <IconChevronDown
            className={`ml-[6px] h-[15px] w-[15px] font-[800] ${
              isExpandAccordion && 'rotate-180'
            } duration-[200ms]`}
          />
        </div>
      </div>
      <div className={`${isExpandAccordion ? 'max-h-fit' : 'max-h-0'} w-full overflow-hidden`}>
        <div className='space-y-[24px] pt-[24px]'>
          <Carousel
            name='project-location'
            medias={projectLocationImages}
            wrapperClassName='space-x-[8px]'
            slideClassName='h-[400px] rounded-[8px] select-none'
            nextIcon={<IconChevronRight className='min-h-[32px] min-w-[32px]' />}
            backIcon={<IconChevronLeft className='min-h-[32px] min-w-[32px]' />}
          />
          {projectLocation && (
            <span className='inline-block whitespace-pre-wrap break-words text-justify leading-[20px]'>
              {projectLocation}
            </span>
          )}
          {/* <div className='flex justify-between'>
            <div className='flex items-center'>
              <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
                <IconLocationOutline className='min-h-[24px] min-w-[24px]' />
              </div>
              <h2 className='ml-[8px] text-[18px] font-[600] leading-[23px]'>
                {translate.desktop.detailProject.realEstateLocation}
              </h2>
            </div>
            <button
              className='flex select-none items-center space-x-[10px] text-primary'
              onClick={toggleMapModal}
            >
              <div className='min-h-[24px] min-w-[24px] bg-[url("/icons/map.svg")] bg-cover bg-center bg-no-repeat' />
              <span className='text-[12px] font-[600] leading-[15px] text-primary'>Xem bản đồ</span>
            </button>
          </div> */}
        </div>
        <ModalWrapper showing={showingMapModal}>
          <MapModal map={map} onClose={toggleMapModal} />
        </ModalWrapper>
      </div>
    </section>
  ) : null;
};

export default ProjectLocation;
